import React from 'react';
import { useSelector } from 'react-redux';
import { bool, string } from 'prop-types';
import { NavLink } from 'react-router-dom';
import cn from 'classnames';
import i18next from 'i18next';

import styles from './styles.module.scss';

function Logo({ className, classNameLogo, homePath, forcePrimary }) {
  const isSecondaryHeader = useSelector((state) => state.core.settings?.secondaryHeader);
  const { primaryLogo, secondaryLogo } = useSelector((state) => state.core.settings);
  return (
    <span>
      <NavLink
        className={cn('row text-center middle center full-height', styles.logoContainer, className)}
        to={homePath}>
        <img
          className={classNameLogo}
          src={isSecondaryHeader && !forcePrimary ? secondaryLogo : primaryLogo}
          alt={i18next.t('App:commerceLogo')}
        />
      </NavLink>
    </span>
  );
}

Logo.propTypes = {
  homePath: string.isRequired,
  className: string,
  classNameLogo: string,
  forcePrimary: bool
};

export default Logo;
